module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/socket.io-parser/~/isarray/index.js
 ** module id = 44
 ** module chunks = 1
 **/